import resources from '../../resources';
import * as websiteActions from './website';

export const TEXTING_ENABLED_CHANGING = 'FACILITY/TEXTING_ENABLED_CHANGING';
export const TEXTING_ENABLED_CHANGED = 'FACILITY/TEXTING_ENABLED_CHANGED';
export const TEXTING_ENABLED_CHANGE_FAILED =
  'FACILITY/TEXTING_ENABLED_CHANGE_FAILED';
export function changeTextingLocalStatus(status) {
  return (dispatch) => {
    dispatch({ type: TEXTING_ENABLED_CHANGING, status });

    return resources.facility
      .putTextingLocalStatus(status)
      .then(() => dispatch(websiteActions.loadBaseData()))
      .then(() => dispatch({ type: TEXTING_ENABLED_CHANGED, status }))
      .catch((error) =>
        dispatch({ type: TEXTING_ENABLED_CHANGE_FAILED, status, error })
      );
  };
}

export const COMMUNICATIONS_ENABLED_CHANGING =
  'FACILITY/COMMUNICATIONS_ENABLED_CHANGING';
export const COMMUNICATIONS_ENABLED_CHANGED =
  'FACILITY/COMMUNICATIONS_ENABLED_CHANGED';
export const COMMUNICATIONS_ENABLED_CHANGE_FAILED =
  'FACILITY/COMMUNICATIONS_ENABLED_CHANGE_FAILED';
export function changeCommunicationsEnabled(enabled: boolean) {
  return (dispatch) => {
    dispatch({ type: COMMUNICATIONS_ENABLED_CHANGING, enabled });

    return resources.facility
      .putCommunicationsEnabled(enabled)
      .then(() => dispatch(websiteActions.loadBaseData()))
      .then(() => dispatch({ type: COMMUNICATIONS_ENABLED_CHANGED, enabled }))
      .catch((error) =>
        dispatch({ type: COMMUNICATIONS_ENABLED_CHANGE_FAILED, enabled, error })
      );
  };
}

export const AUDIO_CALLING_ENABLED_CHANGING =
  'FACILITY/AUDIO_CALLING_ENABLED_CHANGING';
export const AUDIO_CALLING_ENABLED_CHANGED =
  'FACILITY/AUDIO_CALLING_ENABLED_CHANGED';
export const AUDIO_CALLING_ENABLED_CHANGE_FAILED =
  'FACILITY/AUDIO_CALLING_ENABLED_CHANGE_FAILED';
export function changeAudioCallingEnabled(enabled: boolean) {
  return (dispatch) => {
    dispatch({ type: AUDIO_CALLING_ENABLED_CHANGING, enabled });

    return resources.facility
      .putAudioCallEnabled(enabled)
      .then(() => dispatch(websiteActions.loadBaseData()))
      .then(() => dispatch({ type: AUDIO_CALLING_ENABLED_CHANGED, enabled }))
      .catch((error) =>
        dispatch({ type: AUDIO_CALLING_ENABLED_CHANGE_FAILED, enabled, error })
      );
  };
}

export const VIDEO_CALLING_ENABLED_CHANGING =
  'FACILITY/VIDEO_CALLING_ENABLED_CHANGING';
export const VIDEO_CALLING_ENABLED_CHANGED =
  'FACILITY/VIDEO_CALLING_ENABLED_CHANGED';
export const VIDEO_CALLING_ENABLED_CHANGE_FAILED =
  'FACILITY/VIDEO_CALLING_ENABLED_CHANGE_FAILED';
export function changeVideoCallingEnabled(enabled: boolean) {
  return (dispatch) => {
    dispatch({ type: VIDEO_CALLING_ENABLED_CHANGING, enabled });

    return resources.facility
      .putVideoCallEnabled(enabled)
      .then(() => dispatch(websiteActions.loadBaseData()))
      .then(() => dispatch({ type: VIDEO_CALLING_ENABLED_CHANGED, enabled }))
      .catch((error) =>
        dispatch({ type: VIDEO_CALLING_ENABLED_CHANGE_FAILED, enabled, error })
      );
  };
}

export const MUSIC_ENABLED_CHANGING =
  'FACILITY/MUSIC_ENABLED_CHANGING';
export const MUSIC_ENABLED_CHANGED =
  'FACILITY/MUSIC_ENABLED_CHANGED';
export const MUSIC_ENABLED_CHANGE_FAILED =
  'FACILITY/MUSIC_ENABLED_CHANGE_FAILED';
export function changeMusicEnabled(enabled: boolean) {
  return (dispatch) => {
    dispatch({ type: MUSIC_ENABLED_CHANGING, enabled });

    return resources.facility
      .putMusicEnabled(enabled)
      .then(() => dispatch(websiteActions.loadBaseData()))
      .then(() => dispatch({ type: MUSIC_ENABLED_CHANGED, enabled }))
      .catch((error) =>
        dispatch({ type: MUSIC_ENABLED_CHANGE_FAILED, enabled, error })
      );
  };
}

export const REFERENCE_MATERIAL_ENABLED_CHANGING =
  'FACILITY/REFERENCE_MATERIAL_ENABLED_CHANGING';
export const REFERENCE_MATERIAL_ENABLED_CHANGED =
  'FACILITY/REFERENCE_MATERIAL_ENABLED_CHANGED';
export const REFERENCE_MATERIAL_ENABLED_CHANGE_FAILED =
  'FACILITY/REFERENCE_MATERIAL_ENABLED_CHANGE_FAILED';
export function changeReferenceMaterialEnabled(enabled: boolean) {
  return (dispatch) => {
    dispatch({ type: REFERENCE_MATERIAL_ENABLED_CHANGING, enabled });

    return resources.facility
      .putReferenceMaterialEnabled(enabled)
      .then(() => dispatch(websiteActions.loadBaseData()))
      .then(() => dispatch({ type: REFERENCE_MATERIAL_ENABLED_CHANGED, enabled }))
      .catch((error) =>
        dispatch({ type: REFERENCE_MATERIAL_ENABLED_CHANGE_FAILED, enabled, error })
      );
  };
}
